export function TermsContent() {
  return (
    <>
      <h3>1. Agreement</h3>
      <p>
        These Terms of Service (&quot;Terms&quot;) constitute a legal agreement between you
        (&quot;User&quot;) and SSP Enterprise (&quot;Company,&quot; &quot;we,&quot; &quot;us&quot;),
        governing your use of the SSP Enterprise platform. By accessing or using the platform, you
        agree to be bound by these Terms.
      </p>

      <h3>2. Service Description</h3>
      <p>
        SSP Enterprise is a self-custodial multi-signature platform for organisations. The platform
        provides organisation management, multi-signature vault management, transaction proposal
        workflows, a configurable policy engine, portfolio tracking, and subscription services.
      </p>

      <h3>3. Self-Custody</h3>
      <p>
        SSP Enterprise is a non-custodial platform.{' '}
        <strong>We never hold, access, or store your private keys.</strong> All cryptographic
        signing occurs exclusively on your own devices. You are solely responsible for the security
        of your keys and devices. Lost or compromised keys may result in permanent loss of access to
        your digital assets. We cannot recover keys, reverse transactions, or restore access to
        vaults under any circumstances.
      </p>

      <h3>4. Account and Organisations</h3>
      <p>
        You are responsible for maintaining the security of your account and for all activities
        conducted through your organisation. Organisation owners and administrators are responsible
        for managing membership, roles, and permissions.
      </p>

      <h3>5. Multi-Party Responsibility</h3>
      <p>
        In multi-signer configurations, each signer is independently responsible for the security of
        their own keys and devices. We are not liable for actions taken by any signer within your
        organisation.
      </p>

      <h3>6. Policy Engine</h3>
      <p>
        Transaction policies (spending limits, address whitelists, time-locks, approval rules) are{' '}
        <strong>software-based controls provided on a best-effort basis</strong>. They do not
        constitute guarantees. On-chain transactions are irreversible regardless of policy settings.
      </p>

      <h3>7. Subscription and Payment</h3>
      <p>
        A free tier is available with limited features. Paid subscriptions unlock additional
        capabilities. No refunds are provided for used subscription periods. We reserve the right to
        modify pricing with 30 days prior notice. Access may be restricted for non-payment.
      </p>

      <h3>8. Availability</h3>
      <p>
        The service is provided on an &quot;as-is&quot; and &quot;as-available&quot; basis without
        warranties of any kind, whether express or implied. We do not guarantee uninterrupted or
        error-free service.
      </p>

      <h3>9. Limitation of Liability</h3>
      <p>
        <strong>
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, SSP ENTERPRISE AND ITS AFFILIATES,
          OFFICERS, DIRECTORS, AND EMPLOYEES SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
          SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, REVENUE, DATA, OR
          DIGITAL ASSETS, WHETHER DIRECT OR INDIRECT, ARISING OUT OF OR IN CONNECTION WITH YOUR USE
          OF THE SERVICE.
        </strong>{' '}
        Our aggregate liability shall not exceed the total fees paid by you in the twelve (12)
        months preceding the claim.
      </p>

      <h3>10. Indemnification</h3>
      <p>
        You agree to indemnify and hold harmless SSP Enterprise from any claims, damages, losses, or
        expenses (including legal fees) arising out of your use of the platform, your violation of
        these Terms, or your violation of any rights of a third party.
      </p>

      <h3>11. Intellectual Property</h3>
      <p>
        All intellectual property rights in the SSP Enterprise platform remain with the Company. You
        are granted a limited, non-exclusive, non-transferable licence to use the platform in
        accordance with these Terms. You may not copy, modify, distribute, or reverse-engineer the
        platform.
      </p>

      <h3>12. Termination</h3>
      <p>
        Either party may terminate this agreement at any time. We may suspend or terminate your
        access for violation of these Terms. Upon termination, your right to use the platform ceases
        immediately. Certain data may be retained as required by law or for legitimate compliance
        purposes.
      </p>

      <h3>13. Modifications</h3>
      <p>
        We reserve the right to modify these Terms at any time. Material changes will be
        communicated via the platform or email. Continued use of the service after modifications
        constitutes acceptance.
      </p>

      <h3>14. Governing Law</h3>
      <p>
        These Terms shall be governed by and construed in accordance with applicable law. Any
        disputes shall be subject to the exclusive jurisdiction of the competent courts.
      </p>

      <h3>15. Contact</h3>
      <p>
        For questions regarding these Terms, contact us at{' '}
        <a href="mailto:enterprise@sspwallet.com">enterprise@sspwallet.com</a>.
      </p>
    </>
  );
}
